module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicator-result box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h4', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.indicator.title))]), _vm._v(" "), (_vm.showFinancialToggle) ? _c('div', {
    staticClass: "box-tools pull-right financial-view-toggle"
  }, [_c('label', {
    staticClass: "sr-only"
  }, [_vm._v("Visualização financeira")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialView),
      expression: "financialView"
    }],
    staticClass: "form-control input-sm",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.financialView = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "nominal"
    }
  }, [_vm._v("Nominal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "deflated"
    }
  }, [_vm._v("Deflacionado (IPCA)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "withoutKnownParkOutliers"
    }
  }, [_vm._v("Sem outliers conhecidos")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.showLineChart && _vm.lineChartData && _vm.chartVisible) ? _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('ReportChartContainer', {
    key: 'line-' + _vm.chartRenderKey + '-' + _vm.financialView,
    attrs: {
      "data": _vm.lineChartData,
      "chart-component": _vm.LineChart
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.snapshotChartData && _vm.chartVisible) ? _c('div', {
    staticClass: "chart-wrapper snapshot-chart"
  }, [_c('ReportChartContainer', {
    key: 'snapshot-' + _vm.chartRenderKey,
    attrs: {
      "data": _vm.snapshotChartData,
      "chart-component": _vm.snapshotChartComponent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.distributionChartData && _vm.chartVisible) ? _c('div', {
    staticClass: "chart-wrapper distribution-chart"
  }, [_c('ReportChartContainer', {
    key: 'distribution-' + _vm.chartRenderKey + '-' + _vm.financialView,
    attrs: {
      "data": _vm.distributionChartData,
      "chart-component": _vm.distributionChartComponent
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.indicator.type === 'table' || _vm.indicator.type === 'ranking') && _vm.tableData) ? _c('div', {
    staticClass: "table-wrapper"
  }, [_c('TableReport', {
    attrs: {
      "data": _vm.tableData
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.nestedTables), function(nestedTable, index) {
    return _c('div', {
      key: 'nested-' + index,
      staticClass: "table-wrapper nested-table"
    }, [_c('TableReport', {
      attrs: {
        "data": nestedTable
      }
    })], 1)
  }), _vm._v(" "), (_vm.indicator.type === 'series' && _vm.seriesDetailTable) ? _c('div', {
    staticClass: "table-wrapper table-scroll"
  }, [_c('TableReport', {
    attrs: {
      "data": _vm.seriesDetailTable
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.comparisonTable) ? _c('div', {
    staticClass: "table-wrapper table-scroll"
  }, [_c('TableReport', {
    attrs: {
      "data": _vm.comparisonTable
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.comparisonNestedTables), function(comparisonNestedTable, index) {
    return _c('div', {
      key: 'comparison-' + index,
      staticClass: "table-wrapper table-scroll nested-table"
    }, [_c('TableReport', {
      attrs: {
        "data": comparisonNestedTable
      }
    })], 1)
  }), _vm._v(" "), (_vm.concentrationText) ? _c('p', {
    staticClass: "concentration-summary text-muted"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" " + _vm._s(_vm.concentrationText) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.indicator.type === 'kpi') ? _c('div', {
    staticClass: "kpi-value"
  }, [_vm._v("\n      " + _vm._s(_vm.kpiValue) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.adjustmentNote) ? _c('p', {
    staticClass: "text-muted adjustment-note"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.adjustmentNote) + "\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd511bbe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/relatorio_estatistico/IndicatorResult.vue
// module id = 767
// module chunks = 1